export const DADOS_BASICOS_PF_DTO = {
  "cpf": "85122220425",
  "nome": "HVITRL XZIOLH ILXSZ",
  "nomeMae": "QLHVUZ WV EZHXLMXVOLH XZIOLH ILXSZ",
  "dataNascimento": "19721205",
  "anoObito": null,
  "sexo": "Masculino",
  "dataInscricao": "19940425",
  "indParticipanteCadeia": "3",
  "cadeiaCpf": [
    "56613983012",
    "93463814005",
    "32127758072"
  ],
  "sizeCadeiaCpf": 0,
  "cpfPontaCadeia": "0",
  "codigoAreaTelefone": 71,
  "numeroTelefone": null,
  "numeroTelefoneCelular": 96114930,
  "endereco": {
    "logradouro": "I ORWRZ YLIQZ",
    "numeroLogradouro": "524",
    "complemento": "APTO 101 BLOCO 2",
    "bairro": "STELLA MARIS",
    "municipio": {
      "codigo": 3849,
      "nome": "SALVADOR",
      "uf": "BA"
    },
    "cep": 41600550
  },
  "ua": {
    "codigo": 518000,
    "nome": "DERAT FEIRA DE SANTANA"
  },
  "situacaoCadastral": {
    "codigo": 0,
    "descricao": "Regular"
  },
  "naturalidade": {
    "codigo": 6475,
    "nome": "GUARUJA",
    "uf": "SP"
  },
  "indEstrangeiro": "Não",
  "nacionalidade": {
    "codigo": null,
    "nome": null
  },
  "indResidenteExterior": "Não",
  "paisResidenciaExterior": {
    "codigo": null,
    "nome": null
  },
  "ocupacaoPrincipal": {
    "codigo": 120,
    "natureza": 1,
    "anoExercicio": 2024
  }
};
